import React from 'react';
import { Box } from '@mui/material';
import { COLOR_APP_PRIMARY, COLOR_WHITE } from '../../theme';

type PropsType = {
    children: React.ReactNode,
    shouldRenderBadge: boolean,
    symbol: string,
    badgeColor?: string,
    badgeTextColor?: string,
    badgeSize?: number,
    top?: number,
    right?: number,
    px?: number,
    borderRadius?: string,
    fontSize?: string,
    fontWeight?: number
};

export default function IconOverlay({
    children,
    shouldRenderBadge = false,
    symbol = '',
    badgeColor = COLOR_APP_PRIMARY,
    badgeTextColor = COLOR_WHITE,
    badgeSize = 20,
    top = 2,
    right = -10,
    px = symbol.length > 1 ? 0.75 : 0,
    borderRadius = '999px',
    fontSize = '0.7rem',
    fontWeight = 700
}: PropsType) {
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'inline-flex',
                width: 'fit-content',
                verticalAlign: 'middle'
            }}
        >
            {children}
            {shouldRenderBadge && (
                <Box
                    component="span"
                    sx={{
                        position: 'absolute',
                        top,
                        right,
                        transform: 'translate(35%, -35%)',
                        minWidth: `${badgeSize}px`,
                        height: `${badgeSize}px`,
                        px,
                        borderRadius,
                        backgroundColor: badgeColor,
                        color: badgeTextColor,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize,
                        fontWeight,
                        lineHeight: 1,
                        border: '2px solid #FFFFFF',
                        boxSizing: 'border-box',
                        pointerEvents: 'none'
                    }}
                >
                    {symbol}
                </Box>
            )}
        </Box>
    );
}
